import React, { useState } from 'react';
import { colors, styles } from '../styles/styles';
import { createCollectionModalStyles as modalStyles } from '../styles/createCollectionModal.styles';
import { createCollection } from '../services/collectionService';

/**
 * Modal for creating a new collection
 */
const CreateCollectionModal = ({ isVisible, onClose, onSuccess }) => {
    const [name, setName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const handleClose = () => {
        setName('');
        onClose();
    };
    
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim() || isSubmitting) return;
        
        setIsSubmitting(true);
        try {
            // Create the collection
            await createCollection(name.trim());
            // Call onSuccess with the collection name
            await onSuccess(name.trim());
            handleClose();
        } catch (error) {
            console.error('Error creating collection:', error);
        } finally {
            setIsSubmitting(false);
        }
    };
    
    if (!isVisible) return null;
    
    return (
        <div 
            style={modalStyles.backdrop}
            onClick={handleBackdropClick}
        >
            <div style={modalStyles.container}>
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: styles.formGroup.marginBottom }}>
                        <label 
                            htmlFor="collection-name"
                            style={{
                                ...styles.label,
                                color: colors.textSecondary
                            }}
                        >
                            Collection Name
                        </label>
                        <input
                            id="collection-name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder=""
                            style={modalStyles.input}
                            autoFocus
                        />
                    </div>
                    
                    <div style={modalStyles.buttonContainer}>
                        <button
                            type="button"
                            onClick={handleClose}
                            disabled={isSubmitting}
                            style={modalStyles.cancelButton(isSubmitting)}
                        >
                            Cancel
                        </button>
                        
                        <button
                            type="submit"
                            disabled={!name.trim() || isSubmitting}
                            style={modalStyles.submitButton(!name.trim() || isSubmitting)}
                        >
                            {isSubmitting ? 'Creating...' : 'Create'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateCollectionModal; 